import TabPanelsView from 'backbone/platform/views/tab_panels_view.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class StoryTabPanelsView extends TabPanelsView
  events:
    "click .js-linking-tab a"          : "onLinkClicked"
    "editorImageUploadSuccess"         : "reloadAssets"
    "pluginAltered"                    : "reloadPlugins"
    "click .js-show-content-assist"    : "showContentAssist"
    "click .js-refresh-content-assist" : "refreshContentAssist"

  initialize: (options = {}) ->
    _.extend(@events, TabPanelsView.prototype.events)
    @dispatcher = BackboneDispatcher.get_instance()
    @dispatcher.on("pluginModified", @reloadPlugins)
    @dispatcher.on("openComposeTab", @showCompose)
    super options
    @loadPanel('content-assist') if @panelLoaded("content-assist")

    if window.story.permitted_to_comment
      @commentCollection = page.get("storyComments")
      @listenTo(@commentCollection, "add", @reloadRequirements)

  remove: ->
    @dispatcher.off("pluginModified", @reloadPlugins)
    @dispatcher.off("openComposeTab")
    super()

  reloadActivities: ->
    @loadPanel("activity") if @panelLoaded("activity")

  reloadAssets: ->
    @loadPanel("assets") if @panelLoaded("assets")

  reloadPlugins: ->
    @loadPanel("plugins") if @panelLoaded("plugins")

  reloadRequirements: =>
    @loadPanel("requirements") if @panelLoaded("requirements")

  showContentAssist: ->
    @activatePanel("content-assist")
    @loadPanel("content-assist") if @panelLoaded("content-assist")
    mixpanel.track("content-assist-link-clicked", @_mixpanelData())

  showCompose: => @activatePanel("compose")

  showPanel: (panelName) -> @activatePanel(panelName)

  refreshContentAssist: ->
    @loadPanel("content-assist") if @panelLoaded("content-assist")
    mixpanel.track("content-assist-refresh-clicked", @_mixpanelData())

  onLinkClicked: (event) ->
    link = event.currentTarget
    if link.pathname == window.location.pathname
      event.preventDefault()
      panelName = link.hash.substr(1)

      if panelName == "" || panelName == "compose"
        @activateComposePanel()
      else
        @activatePanel(panelName)

  _mixpanelData: ->
    story_id: parseInt(@resourceId, 10)
    email: contently.ui.current_user.email
    distinct_id: contently.ui.current_user.id



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/story_tab_panels_view.js.coffee